import { render } from "./TheProfessionalConsultationShow.vue?vue&type=template&id=6ecf999d&scoped=true&ts=true"
import script from "./TheProfessionalConsultationShow.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalConsultationShow.vue?vue&type=script&lang=ts"

import "./TheProfessionalConsultationShow.vue?vue&type=style&index=0&id=6ecf999d&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecf999d"]])

export default __exports__